import { useCallback } from 'react';
import type { FolderDetailCategory } from 'shared/src/api/likedFolderService/getFolderDetailCategories';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import { ALL_CATEGORY, type FolderType } from '../constants';

export const useLogApplySort = (folderType: FolderType) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    (sortType: string, category?: FolderDetailCategory | null) => {
      const target = category ?? ALL_CATEGORY;
      logAnalyticsEvent({
        name: 'APPLY_SORT',
        analytics: {
          SORT_TYPE: sortType,
          FOLDER_TYPE: folderType,
          CATEGORY_SNO: target.sno.toString(),
          CATEGORY_NAME: target.name,
        },
      });
    },
    [logAnalyticsEvent, folderType],
  );
};
